import { Theme } from "@mui/material";
import { gridClasses } from "@mui/x-data-grid-premium";

/**
 * Generates custom row styles for a DataGrid component based on the provided theme.
 *
 * Styles alternate row backgrounds (odd/even), hover states, and pinned columns.
 *
 * @param theme - The Material-UI theme object used to access palette colors.
 * @param withPinnedColumns - Optional flag to apply styles to pinned columns. Defaults to `true`.
 * @returns An object containing CSS-in-JS style rules for DataGrid rows and cells.
 */

export const getDataGridRowStyles = (theme: Theme, withPinnedColumns = true) => {
  const HOVERED_ROW_BG_COLOR = "#F0F8FF";
  const GRAY_BG_COLOR = theme.palette.grey[200];
  const WHITE_BG_COLOR = "#fff";

  const baseCellStyle = (color: string) => ({
    [`& .${gridClasses.cell}`]: { backgroundColor: color },
    ...(withPinnedColumns && {
      [`& .${gridClasses["cell--pinnedLeft"]}, & .${gridClasses["cell--pinnedRight"]}`]: { backgroundColor: color },
    }),
  });

  const hoverCellStyle = {
    [`& .${gridClasses.cell}`]: { backgroundColor: HOVERED_ROW_BG_COLOR },
    ...(withPinnedColumns && {
      [`& .${gridClasses["cell--pinnedLeft"]}, & .${gridClasses["cell--pinnedRight"]}`]: {
        backgroundColor: HOVERED_ROW_BG_COLOR,
      },
    }),
  };

  return {
    [`& .${gridClasses.row}.odd`]: {
      ...baseCellStyle(GRAY_BG_COLOR),
      "&:hover, &.Mui-hovered": hoverCellStyle,
    },
    [`& .${gridClasses.row}.even`]: {
      ...baseCellStyle(WHITE_BG_COLOR),
      "&:hover, &.Mui-hovered": hoverCellStyle,
    },
    [`& .${gridClasses.row}.Mui-selected .${gridClasses.cell}`]: {
      backgroundColor: HOVERED_ROW_BG_COLOR,
    },
    [`& .${gridClasses.menuIcon}`]: {
      visibility: "visible",
      width: "auto",
    },
  };
};
